import { useEffect } from 'react';
import { initializeCallingGlobal } from 'calling-global-api/initialize';
export const useJsApi = () => {
  useEffect(() => {
    // onMount Calling global is ready
    initializeCallingGlobal();
  }, []);
};